export default __webpack_public_path__ + "static/media/avatar-Five.c8098e4f.svg";